<div fxLayout="column">
  <div fxLayout="row" style="font-size: 20px">Country Configuration</div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign.xs="start"
    class="label-view"
    style="margin-top: 20px"
  >
    <div fxFlex="30">Country</div>
    <div fxFlex="40">Secondary Language</div>
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign.xs="start"
    class="text-view"
  >
    <div fxFlex="30">{{ country }}</div>
    <div fxFlex="40">{{ name_secondary_language }}</div>
  </div>

  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign.xs="start"
    class="label-view"
    style="margin-top: 40px"
  >
    <div fxFlex="40">Json for Country Server</div>
    <div fxFlex="20">
      <mat-icon
        class="copy-password"
        style="cursor: pointer"
        (click)="copy_text(genrate)"
        >content_copy</mat-icon
      >
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign.xs="start"
    class="label-view"
    style="margin-top: 20px"
  >
    <div fxFlex="80">
      <mat-form-field appearance="fill" style="width: 285px">
        <textarea
          matInput
          [readonly]="true"
          #genrate
          cdkTextareaAutosize
          cdkAutosizeMinRows="10"
          cdkAutosizeMaxRows="15"
        >
 {{ get_data | json }}</textarea
        >
      </mat-form-field>
    </div>
  </div>

  <div class="button-container" style="margin-top: 20px">
    <button
      mat-button
      (click)="cancel()"
      class="example-button-row"
      class="button-style"
    >
      CANCEL
    </button>
  </div>
</div>
